import React, {ReactElement} from 'react';

import Row from '../../common/Row';
import ProgressBar from './ProgressBar';

type Props = {
  currentYield: number;
  maxYield: number;
};

const YieldCounter = ({currentYield, maxYield}: Props): ReactElement => {
  return (
    <div>
      <Row className={'justify-between text-xl font-medium mobile:text-base'}>
        <div>Current yield</div>
        <div>{currentYield.toFixed(2)} t/ha/yr</div>
      </Row>
      <ProgressBar progress={currentYield / maxYield} className={'mb-md'} />
    </div>
  );
};

export default YieldCounter;
